import { BimPriceAnalyticsItemStatus } from 'gql/graphql';
import type {
    BimPriceAnalyticsItem,
    BimPriceAnalyticsRowData,
    BimPriceLevelEnum,
    BimWorkOrderPriceValue,
    BimWorkOrderPriceData,
} from 'gql/graphql';
import type { BadgePropStatus } from 'uikit';

export type IBimWorkOrderPriceAnalytics = {
    onClose: () => void;
    baseRow: {
        data: BimWorkOrderPriceData;
    };
    priceLevel: BimPriceLevelEnum | undefined;
};

export type TFiltersChangeHandler = {
    changeFiltersHandler?: ({ fieldName, checkedValues }: { fieldName: string; checkedValues: string[] }) => void;
};

export type TProps = {
    priceLevel: BimPriceLevelEnum | undefined;
    workOrderPriceId: number | undefined;
    refWorkOrderPriceId: number | undefined;
};

export type TBadgeItem = {
    text: string;
    color: BadgePropStatus;
};

export type TBaseRowData = {
    topPinnedRow: boolean;
    topPriceValue?: BimWorkOrderPriceValue | null;
    refPriceValue?: BimWorkOrderPriceValue | null;
};

export type TRow =
    | BimPriceAnalyticsRowData
    | (BimPriceAnalyticsItem & {
          isSection?: boolean;
          isSubsection?: boolean;
          status?: BimPriceAnalyticsItemStatus | null;
          topPriceValue: { section?: string | null; subsection?: string | null };
          refPriceValue: { section?: string | null; subsection?: string | null };
      });

export type TAnalyticsData = {
    [key: number]: {
        order?: number;
        rows?: TRow[];
        [key: number]: {
            order?: number;
            rows: TRow[];
        };
    };
};

export type TFilters =
    | {
          [key: string]: string[] | undefined;
      }
    | undefined;

export type TSimpleFilterFields = {
    refHeaderValue?: { name: { eq: string } };
    topHeaderValue?: { name: { eq: string } };
};

export const statusItemProps: {
    [key in BimPriceAnalyticsItemStatus]: {
        label: string;
        status: BadgePropStatus;
    };
} = {
    [BimPriceAnalyticsItemStatus.Added]: {
        label: 'Новых',
        status: 'success',
    },
    [BimPriceAnalyticsItemStatus.Changed]: {
        label: 'Изменено',
        status: 'warning',
    },
    [BimPriceAnalyticsItemStatus.Equals]: {
        label: 'Совпало',
        status: 'system',
    },
    [BimPriceAnalyticsItemStatus.Removed]: {
        label: 'Исключено',
        status: 'error',
    },
    [BimPriceAnalyticsItemStatus.Replaced]: {
        label: 'Заменено',
        status: 'normal',
    },
    [BimPriceAnalyticsItemStatus.None]: {
        label: '',
        status: 'normal',
    },
};
